import config from "@/config/config";

/**
 * Constrói a URL completa para o vídeo.
 * Aceita:
 * - filename simples (ex: "abc123.mp4") → {apiBaseUrl}/media/video/{filename}
 * - URL completa (http/https) → retorna como está (suporte admin)
 * - undefined/empty → ""
 */
export const getVideoUrl = (videoName: string | undefined): string => {
  if (!videoName) return "";

  if (videoName.startsWith("http://") || videoName.startsWith("https://")) {
    return videoName;
  }

  return `${config.apiBaseUrl}/${config.videoUrl}/${videoName}`;
};

export default getVideoUrl;
